/* Komodin ürün sayfası çalışma zamanı (tema sahibi kod): galeri + küçük görseller + oklar (R-galeri), hover büyüteci (C9),
   varyant seçimi (CA-54, yerinde), adet, 17:00 geri sayımı (CA-52), "Tüm ürün özellikleri" çapası, değerlendirme formu.
   Sepete ekleme ve paylaşım ortak modüllerde (kt-runtime.js). */
(function () {
  'use strict';
  var d = document, w = window;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function money(cents) { return (w.KT && w.KT.money) ? w.KT.money(cents / 100) : (cents / 100).toFixed(2) + ' TL'; }

  function init() {
    var root = qs('[data-kt-product]'); if (!root) return;
    var data; try { data = JSON.parse(qs('[data-kt-product-json]', root).textContent); } catch (e) { return; }
    var media = data.media || [];
    var galleries = qsa('[data-kt-gallery]', root).map(function (g) { return gallery(g, media); });
    function showAll(i) { galleries.forEach(function (g) { g.show(i); }); }
    variants(root, data, showAll);
    qty(root);
    countdown(root);
    jump(root);
    reviews(root);
  }

  /* ---------- galeri ---------- */
  function gallery(g, media) {
    var idx = Number(g.getAttribute('data-start')) || 0;
    var img = qs('[data-kt-main-img]', g), thumbs = qsa('[data-kt-thumb]', g), col = qs('[data-kt-thumbs]', g);
    function show(i) {
      if (!media.length) return;
      idx = (i + media.length) % media.length;
      var m = media[idx];
      if (img && img.getAttribute('data-src') !== m.src) {
        img.removeAttribute('srcset'); img.src = m.src; img.alt = m.alt || ''; img.setAttribute('data-src', m.src);
        img.width = m.w; img.height = m.h;
      }
      thumbs.forEach(function (t, k) {
        var on = k === idx;
        ['border-black', 'ring-2', 'ring-black/10', 'shadow-sm'].forEach(function (c) { t.classList.toggle(c, on); });
        ['border-gray-200', 'hover:border-gray-400'].forEach(function (c) { t.classList.toggle(c, !on); });
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && col && col.scrollHeight > col.clientHeight) {
          var top = t.offsetTop - col.offsetTop, bot = top + t.offsetHeight;
          if (top < col.scrollTop) col.scrollTop = top - 4; else if (bot > col.scrollTop + col.clientHeight) col.scrollTop = bot - col.clientHeight + 4;
        }
      });
      if (zoom && zoom.active) zoom.refresh();
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var pv = qs('[data-kt-gal-prev]', g), nx = qs('[data-kt-gal-next]', g);
    if (pv) pv.addEventListener('click', function (e) { e.preventDefault(); show(idx - 1); });
    if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); show(idx + 1); });
    /* dokunmatik kaydırma (mobil) */
    var stage = qs('[data-kt-stage]', g), sx = null, sy = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = sy = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    var zoom = magnifier(g, function () { return media[idx]; });
    return { show: show };
  }

  /* ---------- hover büyüteci (C9): ince işaretçi, genişlik >= 768, sağda >= 260 px boşluk; x2.5 ---------- */
  function magnifier(g, current) {
    var stage = qs('[data-kt-stage]', g), inner = qs('[data-kt-stage-inner]', g), lens = qs('[data-kt-lens]', g);
    if (!stage || !inner || !lens || !w.matchMedia) return null;
    var mq = w.matchMedia('(hover: hover) and (pointer: fine)');
    var Z = 2.5, pane = null, paneIn = null, geo = null, last = null, api = { active: false, refresh: function () {} };
    function shown(r) {
      var m = current(); if (!m || !m.w || !m.h) return { x: 0, y: 0, w: r.width, h: r.height };
      var s = Math.min(r.width / m.w, r.height / m.h), dw = m.w * s, dh = m.h * s;
      return { x: (r.width - dw) / 2, y: (r.height - dh) / 2, w: dw, h: dh };
    }
    function paneGeo() {
      var a = stage.getBoundingClientRect(); if (a.width <= 0 || a.height <= 0) return null;
      var main = stage.closest('main'), right;
      if (main) { var mr = main.getBoundingClientRect(); right = mr.right - (parseFloat(getComputedStyle(main).paddingRight) || 0); } else right = w.innerWidth - 16;
      var width = Math.min(right - (a.right + 16), Z * shown(inner.getBoundingClientRect()).w);
      if (width < 260) return null;
      var h = Math.min(a.height, w.innerHeight - 32), maxTop = Math.max(16, w.innerHeight - h - 16);
      return { top: Math.min(Math.max(a.top, 16), maxTop), left: a.right + 16, width: width, height: h };
    }
    function place(cx, cy) {
      if (!geo) return;
      var l = inner.getBoundingClientRect(), i = shown(l), o = geo.width / Z, dh = geo.height / Z;
      function c(v, lo, hi) { return hi < lo ? (lo + hi) / 2 : Math.min(Math.max(v, lo), hi); }
      var u = c(cx - l.left, i.x + o / 2, i.x + i.w - o / 2), m = c(cy - l.top, i.y + dh / 2, i.y + i.h - dh / 2);
      var gx = u - o / 2, gy = m - dh / 2;
      lens.style.width = o + 'px'; lens.style.height = dh + 'px'; lens.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
      var cur = current();
      if (cur && paneIn) {
        var bg = 'url("' + cur.zoom + '"), url("' + cur.src + '")';
        if (paneIn.getAttribute('data-bg') !== bg) { paneIn.style.backgroundImage = bg; paneIn.setAttribute('data-bg', bg); }
        paneIn.style.backgroundSize = (Z * i.w) + 'px ' + (Z * i.h) + 'px';
        var pos = ((i.x - gx) * Z) + 'px ' + ((i.y - gy) * Z) + 'px';
        paneIn.style.backgroundPosition = pos + ', ' + pos;
      }
    }
    function open() {
      geo = paneGeo();
      if (!geo) { close(); return false; }
      if (!pane) {
        pane = d.createElement('div'); pane.setAttribute('aria-hidden', 'true');
        pane.className = 'pointer-events-none fixed z-[9000] overflow-hidden rounded-xl border border-[#E7E7E7] bg-white shadow-2xl';
        paneIn = d.createElement('div'); paneIn.className = 'absolute inset-0'; paneIn.style.backgroundRepeat = 'no-repeat';
        pane.appendChild(paneIn); d.body.appendChild(pane);
      }
      pane.style.top = geo.top + 'px'; pane.style.left = geo.left + 'px'; pane.style.width = geo.width + 'px'; pane.style.height = geo.height + 'px';
      lens.style.opacity = '1'; api.active = true;
      return true;
    }
    function close() {
      lens.style.opacity = '0'; api.active = false; geo = null;
      if (pane && pane.parentNode) pane.parentNode.removeChild(pane);
      pane = null; paneIn = null;
    }
    function enabled() { return mq.matches && w.innerWidth >= 768; }
    stage.addEventListener('mouseenter', function (e) { if (!enabled()) return; last = { x: e.clientX, y: e.clientY }; if (open()) place(e.clientX, e.clientY); });
    stage.addEventListener('mousemove', function (e) {
      if (!enabled()) return; last = { x: e.clientX, y: e.clientY };
      if (!api.active) { if (!open()) return; }
      place(e.clientX, e.clientY);
    });
    stage.addEventListener('mouseleave', close);
    w.addEventListener('scroll', function () { if (api.active && last) { if (open()) place(last.x, last.y); } }, { passive: true });
    api.refresh = function () { if (api.active && last) { if (open()) place(last.x, last.y); } };
    return api;
  }

  /* ---------- varyantlar (yerinde seçim) ---------- */
  function variants(root, data, showAll) {
    var vs = data.variants || []; if (!vs.length) return;
    var inputs = qsa('[data-kt-variant-input]', root);
    var curId = inputs.length ? Number(inputs[0].value) : vs[0].id;
    var cur = vs.filter(function (v) { return v.id === curId; })[0] || vs[0];
    var sel = cur.options.slice();
    var keep = Number(root.getAttribute('data-keep')) || 100, freeMin = Number(root.getAttribute('data-free-min')) || 150000;
    var disc = root.getAttribute('data-disc') === 'true';
    var freeMinTl = Number(root.getAttribute('data-free-min-tl')) || 1500;
    function cart(c) { return Math.floor((c * keep + 50) / 100); }
    function find(opts) {
      for (var i = 0; i < vs.length; i++) { var ok = true; for (var k = 0; k < opts.length; k++) if (vs[i].options[k] !== opts[k]) { ok = false; break; } if (ok) return vs[i]; }
      return null;
    }
    function tileAvailable(oi, val) {
      return vs.some(function (v) {
        if (v.options[oi] !== val || !v.available) return false;
        for (var k = 0; k < sel.length; k++) if (k !== oi && v.options[k] !== sel[k]) return false;
        return true;
      });
    }
    function paint(v) {
      qsa('[data-kt-option-tile]', root).forEach(function (t) {
        var oi = Number(t.getAttribute('data-kt-option-tile')), val = t.getAttribute('data-value');
        var on = sel[oi] === val, av = tileAvailable(oi, val);
        ['border-themeDefaultColor', 'bg-neutral-50', 'ring-1', 'ring-neutral-200'].forEach(function (c) { t.classList.toggle(c, on); });
        ['border-gray-200', 'hover:border-themeDefaultColor', 'hover:scale-105'].forEach(function (c) { t.classList.toggle(c, !on); });
        t.classList.toggle('kt-varyant--yok', !av);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        var chk = qs('[data-kt-tile-check]', t); if (chk) chk.classList.toggle('hidden', !on);
      });
      qsa('[data-kt-option]', root).forEach(function (o) {
        var oi = Number(o.getAttribute('data-kt-option')), lab = qs('[data-kt-option-value]', o); if (lab) lab.textContent = sel[oi];
      });
      sel.forEach(function (val, oi) {
        qsa('[data-kt-feature="' + oi + '"],[data-kt-spec-value="' + oi + '"]', root).forEach(function (el) { el.textContent = val; });
      });
      if (!v) return;
      inputs.forEach(function (i) { i.value = v.id; });
      /* CA-101: kampanya açıkken üstü çizili liste + kalın ödenecek tutar; kapalıyken liste fiyatı ve gerçek compare_at */
      qsa('[data-kt-p-price]', root).forEach(function (el) { el.textContent = money(v.price); });
      qsa('[data-kt-p-compare]', root).forEach(function (el) { var on = v.compare > v.price; el.classList.toggle('hidden', !on); el.textContent = on ? money(v.compare) : ''; });
      qsa('[data-kt-p-list]', root).forEach(function (el) { el.textContent = money(v.price); });
      qsa('[data-kt-p-sepette],[data-kt-cart-price]', root).forEach(function (el) { el.textContent = 'Sepette ' + money(cart(v.price)); });
      qsa('[data-kt-bar-price]', root).forEach(function (el) { el.textContent = money(disc ? cart(v.price) : v.price); });
      qsa('[data-kt-bar-sub]', root).forEach(function (el) {
        var sub = disc ? v.price : (v.compare > v.price ? v.compare : 0);
        el.classList.toggle('invisible', !sub); el.textContent = sub ? money(sub) : '\u00a0';
      });
      var base = disc ? cart(v.price) : v.price, free = base >= freeMin;
      var shipTxt = free ? 'Ücretsiz Kargo' : freeMinTl.toLocaleString('tr-TR') + ' TL üzeri kargo bedava';
      qsa('[data-kt-ship-chip]', root).forEach(function (el) { el.textContent = shipTxt; });
      qsa('[data-kt-bar-ship]', root).forEach(function (el) { el.textContent = free ? 'Ücretsiz kargo' : shipTxt; });
      qsa('[data-kt-buy-btn]', root).forEach(function (b) { b.disabled = !v.available; var l = qs('[data-kt-buy-label]', b); if (l) l.textContent = v.available ? 'Sepete Ekle' : 'Tükendi'; });
      qsa('[data-kt-qty-input]', root).forEach(function (q) { q.max = v.max || 20; if (Number(q.value) > q.max) q.value = q.max; q.dispatchEvent(new Event('change')); });
      if (v.media >= 0) showAll(v.media);
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-kt-option-tile]'); if (!t) return;
      e.preventDefault();
      var oi = Number(t.getAttribute('data-kt-option-tile')), val = t.getAttribute('data-value');
      sel[oi] = val;
      var v = find(sel);
      if (!v) { v = vs.filter(function (x) { return x.options[oi] === val && x.available; })[0] || vs.filter(function (x) { return x.options[oi] === val; })[0]; if (v) sel = v.options.slice(); }
      cur = v || cur;
      paint(v);
      if (v) {
        try {
          var u = new URL(location.href); u.searchParams.set('variant', v.id);
          /* Tur 5: renk karosu kaynak gibi tam sayfa geçişi (yeni sayfa başa açılır, seçili varyant işaretli); aynı varyantta geçiş yok */
          if (t.hasAttribute('data-kt-renk') && v.id !== curId) { u.hash = ''; w.location.assign(u.toString()); return; }
          history.replaceState(null, '', u.toString());
        } catch (err) {}
      }
    });
    paint(cur);
  }

  /* ---------- adet ---------- */
  function qty(root) {
    qsa('[data-kt-qty]', root).forEach(function (box) {
      var inp = qs('[data-kt-qty-input]', box), mi = qs('[data-kt-qty-minus]', box), pl = qs('[data-kt-qty-plus]', box);
      if (!inp) return;
      function sync() {
        var max = Number(inp.max) || 20, v = Math.max(1, Math.min(max, parseInt(inp.value, 10) || 1));
        inp.value = v; if (mi) mi.disabled = v <= 1; if (pl) pl.disabled = v >= max;
      }
      if (mi) mi.addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) - 1; sync(); });
      if (pl) pl.addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; sync(); });
      inp.addEventListener('change', sync); inp.addEventListener('blur', sync);
      sync();
    });
  }

  /* ---------- geri sayım (CA-52): "{süre} içinde sipariş verirseniz en geç {gün} kargoda!" (hesap KT.kargoPlan) ---------- */
  function countdown(root) {
    var els = qsa('[data-kt-countdown]', root); if (!els.length || !w.KT || !w.KT.kargoPlan) return;
    var cutoff = Number(root.getAttribute('data-cutoff')) || 17, gun = Number(root.getAttribute('data-handling'));
    if (isNaN(gun)) gun = 1;
    var hol = (root.getAttribute('data-holidays') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    /* Tur 5: sayaç tabular-nums, her sayı sabit min-width'li hanede (.kt-sayac-h, iki tabular basamak) */
    function h(n) { return '<span class="kt-sayac-h">' + n + '</span>'; }
    function fmt(ms) {
      var min = Math.max(1, Math.ceil(ms / 60000)), dd = Math.floor(min / 1440), hh = Math.floor((min % 1440) / 60), mm = min % 60;
      if (dd > 0) return h(dd) + ' gün ' + h(hh) + ' saat';
      if (hh > 0) return h(hh) + ' saat ' + h(mm) + ' dakika';
      return h(mm) + ' dakika';
    }
    function tick() {
      var now = Date.now(), plan = w.KT.kargoPlan(now, cutoff, hol, gun); if (!plan) return;
      els.forEach(function (el) {
        var t = qs('[data-kt-cd-time]', el), dday = qs('[data-kt-cd-day]', el);
        if (t) t.innerHTML = '<span class="kt-sayac">' + fmt(plan.deadline - now) + '</span> içinde';
        if (dday) dday.textContent = plan.when + ' kargoda!';
      });
    }
    tick(); setInterval(tick, 30000);
  }

  /* ---------- "Tüm ürün özellikleri" çapası ---------- */
  function jump(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-kt-specs-jump]'); if (!b) return;
      e.preventDefault();
      /* Tur 5: kaynakla aynı hedef ve ofset — #product-details ("Ürün Bilgileri") scrollIntoView({block:'start'}), ofset yok */
      var t = d.getElementById('product-details'); if (!t) return;
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- değerlendirme formu aç/kapa (CA-58) ---------- */
  function reviews(root) {
    var btn = qs('[data-kt-review-toggle]', root), panel = qs('[data-kt-review-panel]', root);
    if (!btn || !panel) return;
    function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    btn.addEventListener('click', function () { set(panel.hidden); if (!panel.hidden) { var f = qs('input:not([type=hidden])', panel); if (f) f.focus({ preventScroll: true }); } });
    if (qs('[data-kt-review-open]', panel) || btn.getAttribute('aria-expanded') === 'true') set(true);
  }

  if (w.KT && w.KT.register) w.KT.register(init);
  else if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
